import { motion } from "framer-motion";
import { Camera, Sparkles, Info } from "lucide-react";
import { useI18n } from "../i18n";

export const Gallery = () => {
  const { t } = useI18n();

  return (
    <section id="realisations" data-testid="gallery-section" className="relative py-28 md:py-36 px-6 md:px-10 bg-[#070809] border-y border-cyan-500/10">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-12">
          <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-cyan">{t("gallery.tag")}</span>
          <h2 className="font-display font-700 uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-none">
            {t("gallery.title")} <span className="text-cyan">/</span> {t("gallery.titleAfter")}
          </h2>
        </div>

        <motion.div
          data-testid="prelaunch-gallery-placeholder"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-cyan-500/20 bg-[#0B0D10] aspect-[16/10] flex flex-col items-center justify-center text-center p-8 md:p-14"
        >
          <div className="absolute inset-0 opacity-40 radial-cyan pointer-events-none" />
          <div
            className="absolute inset-0 opacity-[0.05] pointer-events-none"
            style={{
              backgroundImage:
                "linear-gradient(rgba(0,229,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(0,229,255,0.4) 1px, transparent 1px)",
              backgroundSize: "48px 48px",
            }}
          />

          <div className="relative">
            <div className="mx-auto h-16 w-16 rounded-full border border-cyan-400/40 bg-cyan-400/10 flex items-center justify-center">
              <Camera size={26} className="text-cyan" />
            </div>

            <span className="inline-flex mt-6 items-center gap-2 rounded-full border border-cyan-400/40 bg-cyan-400/10 px-3 py-1 font-mono-accent text-[10px] uppercase tracking-[0.25em] text-cyan">
              <Sparkles size={12} /> {t("preLaunch.badge")}
            </span>

            <h3 className="font-display font-700 uppercase tracking-tight text-2xl md:text-4xl mt-5 leading-tight max-w-2xl mx-auto">
              {t("preLaunch.galleryTitle")}
            </h3>

            <p className="text-neutral-400 font-light mt-4 max-w-xl mx-auto text-sm md:text-base">
              {t("preLaunch.galleryBody")}
            </p>
          </div>
        </motion.div>

        <div
          data-testid="ai-disclaimer"
          className="mt-6 flex items-start gap-3 rounded-xl border-l-2 border-cyan-400 bg-white/[0.02] px-5 py-4"
        >
          <Info size={18} className="text-cyan shrink-0 mt-0.5" />
          <p className="text-neutral-400 text-sm font-light">{t("preLaunch.aiDisclaimer")}</p>
        </div>
      </div>
    </section>
  );
};
